export const GRAYLOG_ERROR_CODES = {
  oktaUnknownError: "E0001",
  oktaLoginRedirectError: "E0002",
  nonceMismatch: "E0003",
  graylogUnknownError: "E0004"
};
export const createSuccessLoginMetric = (action, inc = 1) => ({
  name: `org.graylog.plugins.cloud.auth.${action}.success`,
  inc
});
export const createFailureLoginMetric = (action, subsystem, code, inc = 1) => ({
  name: `org.graylog.plugins.cloud.auth.${action}.failure.${subsystem}.${code}`,
  inc
});
